import api from "../api";
import { GET_ERRORS,GET_BATCHES, GET_BATCH, DELETE_BATCH } from "./types";

export const createBatch = (batch, history) => async dispatch => {
  try {
    await api.post("/api/receiptBatches", batch);
    history.push("/batch-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    });
  }
};


export const postBatchList = (file,batchId, history) => async dispatch => {
  if (
    window.confirm(
      "Are you sure you want to upload file?"
    )
  ) { try {
   
    let formData = new FormData();
    formData.append("files", file);
    await api.post(`/api/receipt-batches/${batchId}`,formData,{
      headers:{
        'Content-Type':'multipart/form-data'
      }
    });
    history.push("/batch-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    });
  }
}
};





export const updateBatch = (batch, history) => async dispatch => {
  try {
    await api.put(`/api/receiptBatches/${batch.id}`, batch);
    history.push("/batch-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    });
  }
};

export const getBatches = () => async dispatch => {
  const res = await api.get("/api/receiptBatches");
  dispatch({
    type: GET_BATCHES,
    payload: res.data
    
  });
  
};

export const getBatch = (id, history) => async dispatch => {
  try {
    const res = await api.get(`/api/receiptBatches/${id}`);
    
    dispatch({
      type: GET_BATCH,
      payload: res.data
    });
  } catch (error) {
    dispatch({
        type: GET_ERRORS,
        payload: error.response.data
      })
  }
};

export const deleteBatch = id => async dispatch => {
  if (
    window.confirm(
      "Are you sure? This will delete the batch and all the data related to it"
    )
  ) {
    await api.delete(`/api/receiptBatches/${id}`);
    dispatch({
      type: DELETE_BATCH,
      payload: id
    });
  }
};


export const getActiveBatches = (batchDate, history) => {
console.log("Batch Date being sent "+batchDate)
  api(`/api/batch-list/${batchDate}`, {
    method: 'GET',
    responseType: 'blob' //Force to receive data in a Blob Format
  })
    .then(response => {
      //Create a Blob from the PDF Stream
      const file = new Blob(
        [response.data],
        { type: 'application/pdf' });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //Open the URL on new Window

      window.open(fileURL);
    })
    .catch(error => {
      console.log(error);
    });
};

export const getBatchReport = (batchId, history) => {
  console.log("Batch Date being sent "+batchId)
    api(`/api/batch-print/${batchId}`, {
      method: 'GET',
      responseType: 'blob' //Force to receive data in a Blob Format
    })
      .then(response => {
        //Create a Blob from the PDF Stream
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
  
        window.open(fileURL);
      })
      .catch(error => {
        console.log(error);
      });
  };